/**
 *
 * action menu item 14691(BC Vozdvizhenka)
 *
 */

import React from "react";

import Done from "@material-ui/icons/Done";
import FileCopy from '@material-ui/icons/FileCopy';
import {requestAction} from "domain/typeConstants/action";
import {requestStatus} from "domain/typeConstants/status";
import {getValueFromLocalStorage} from "utils/localStorage";
import {GLOBAL_USER_KEY} from "global-constants";
import {ON_CAR_ENTRY, ON_PROPERTY_BRINGING, ON_PROPERTY_REMOVAL} from 'domain/Data/RequestType/constants';
import Clear from "@material-ui/icons/Clear";

export const acceptActionItem = {
    name: requestAction.ACCEPT,
    label: 'Принять',
    icon: 'done',
    svgIcon: <Done/>,
    hidden: (itemMenuRecord, entities, currentRecord) => {
        if (currentRecord) {
            if (!currentRecord.status) return false
            return [requestStatus.CLOSED, requestStatus.COMPLETED, requestStatus.ACCEPTED,
                    requestStatus.IN_PROGRESS, requestStatus.AGREED].includes(currentRecord.status.name)
                || (currentRecord.status.name === requestStatus.REJECTED
                    && currentRecord.agreedEmployee?.id !== getValueFromLocalStorage(GLOBAL_USER_KEY).id
                )
        }
        return true;
    },
};

export const acceptActionItemReception = {
    name: requestAction.ACCEPT,
    label: 'Принять',
    icon: 'done',
    svgIcon: <Done/>,
    hidden: (itemMenuRecord, entities, currentRecord) => {
        if (currentRecord) {
            if (currentRecord.type.id === ON_PROPERTY_BRINGING || currentRecord.type.id === ON_PROPERTY_REMOVAL) return true
            if (!currentRecord.status) return false
            return [requestStatus.CLOSED, requestStatus.COMPLETED, requestStatus.ACCEPTED,
                    requestStatus.IN_PROGRESS, requestStatus.AGREED].includes(currentRecord.status.name)
                || (currentRecord.status.name === requestStatus.REJECTED
                    && currentRecord.agreedEmployee?.id !== getValueFromLocalStorage(GLOBAL_USER_KEY).id
                )
        }
        return true;
    },
};

export const rejectActionItemReception = {
    name: requestAction.REJECT,
    label: 'Отклонить',
    icon: 'clear',
    svgIcon: <Clear/>,
    hidden: (itemMenuRecord, entities, currentRecord) => {
        if (currentRecord) {
            if (currentRecord.type.id === ON_PROPERTY_BRINGING || currentRecord.type.id === ON_PROPERTY_REMOVAL) return true
            if (!currentRecord.status) return false
            return [requestStatus.CLOSED, requestStatus.COMPLETED, requestStatus.REJECTED, requestStatus.AGREED].includes(currentRecord.status.name)
        } else if (itemMenuRecord.length !== 0) {
            if (!entities[0].status) return false;
            return [requestStatus.CLOSED, requestStatus.COMPLETED, requestStatus.REJECTED, requestStatus.AGREED].includes(entities[0].status.name)
        }
        return true;
    },
};

export const copyActionItem = {
    name: requestAction.COPY,
    label: 'Копия',
    icon: 'content_copy',
    svgIcon: <FileCopy/>,
    hidden: (itemMenuRecord, entities, currentRecord) => {
        if (currentRecord) {
            if (!currentRecord.type) return false
            return currentRecord.type.id !== ON_CAR_ENTRY
        }
        return true;
    },
};
